export var CURRENCY_SGD = 'SGD';
export var CURRENCY_CNY = 'CNY';